import { Box, Button } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { getDateRange } from '../utils/methods';

export default function FilterButtons({ setValue = () => {}, watch, defaultToToday = false, resetToToday = false }) {
  const [activeDay, setActiveDay] = useState(defaultToToday ? 1 : 0);

  // Helper functions to get current week's Monday-Sunday and current month's 1st and last day
  const getCurrentWeek = () => {
    const today = new Date();
    const day = today.getDay();
    const diffToMonday = day === 0 ? -6 : 1 - day;
    const monday = new Date(today.setDate(today.getDate() + diffToMonday));
    const sunday = new Date(today.setDate(today.getDate() + 6));
    const from = new Date(monday.setHours(0, 0, 0, 0));
    const to = new Date(sunday.setHours(23, 59, 59, 999));
    return { from, to };
  };

  const getCurrentMonth = () => {
    const today = new Date();
    const from = new Date(today.getFullYear(), today.getMonth(), 1);
    const to = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    return { from, to };
  };

  const handleChangeDate = (daysDecrease, index) => {
    setActiveDay(index);

    if (daysDecrease === false) {
      if (defaultToToday) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        setValue('registeredDateTo', today);
        setValue('registeredDateFrom', today);
        setActiveDay(1);
      } else {
        setValue('registeredDateTo', '');
        setValue('registeredDateFrom', '');
        setActiveDay(0);
      }
      return;
    }

    let from, to;

    if (daysDecrease === -1) {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      from = new Date(yesterday.setHours(0, 0, 0, 0));
      to = new Date(yesterday.setHours(0, 0, 0, 0));
    } else if (daysDecrease === -7) {
      const { from: weekFrom, to: weekTo } = getCurrentWeek();
      from = weekFrom;
      to = weekTo;
    } else if (daysDecrease === -30) {
      const { from: monthFrom, to: monthTo } = getCurrentMonth();
      from = monthFrom;
      to = monthTo;
    } else {
      const { from: customFrom, to: customTo } = getDateRange(daysDecrease);
      from = customFrom;
      to = customTo;
    }

    setValue('registeredDateTo', to);
    setValue('registeredDateFrom', from);
  };

  // 컴포넌트 마운트 시 defaultToToday가 true이면 오늘 날짜로 설정
  useEffect(() => {
    if (defaultToToday) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      setValue('registeredDateTo', today);
      setValue('registeredDateFrom', today);
      setActiveDay(1);
    }
  }, [defaultToToday, setValue]);

  // resetToToday prop이 변경될 때 오늘 버튼으로 초기화
  useEffect(() => {
    if (resetToToday && defaultToToday) {
      setActiveDay(1);
    }
  }, [resetToToday, defaultToToday]);

  useEffect(() => {
    if (watch('registeredDateTo') === '' && watch('registeredDateFrom') === '') {
      setActiveDay(defaultToToday ? 1 : 0);
    }
  }, [watch('registeredDateTo'), watch('registeredDateFrom'), defaultToToday]);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Button
        onClick={() => handleChangeDate(0, 1)}
        sx={{
          borderRadius: '5px',
          fontSize: '13px',
          minWidth: '108px',
          height: '40px',
          mr: 1,
          color: activeDay === 1 ? '#fff' : '#4A4A4A',
          background: activeDay === 1 ? '#4AB3BC' : '#F5F5F5',
          '&:hover': {
            background: activeDay === 1 ? '#4AB3BC' : '#F5F5F5',
          },
        }}>
        일간
      </Button>
      <Button
        onClick={() => handleChangeDate(-1, 2)}
        sx={{
          borderRadius: '5px',
          fontSize: '13px',
          minWidth: '108px',
          height: '40px',
          mr: 1,
          color: activeDay === 2 ? '#fff' : '#4A4A4A',
          background: activeDay === 2 ? '#4AB3BC' : '#F5F5F5',
          '&:hover': {
            background: activeDay === 2 ? '#4AB3BC' : '#F5F5F5',
          },
        }}>
        어제
      </Button>
      <Button
        onClick={() => handleChangeDate(-7, 3)}
        sx={{
          borderRadius: '5px',
          fontSize: '13px',
          minWidth: '108px',
          height: '40px',
          mr: 1,
          color: activeDay === 3 ? '#fff' : '#4A4A4A',
          background: activeDay === 3 ? '#4AB3BC' : '#F5F5F5',
          '&:hover': {
            background: activeDay === 3 ? '#4AB3BC' : '#F5F5F5',
          },
        }}>
        주간
      </Button>
      <Button
        onClick={() => handleChangeDate(-30, 4)}
        sx={{
          borderRadius: '5px',
          fontSize: '13px',
          minWidth: '108px',
          height: '40px',
          mr: 1,
          color: activeDay === 4 ? '#fff' : '#4A4A4A',
          background: activeDay === 4 ? '#4AB3BC' : '#F5F5F5',
          '&:hover': {
            background: activeDay === 4 ? '#4AB3BC' : '#F5F5F5',
          },
        }}>
        월간
      </Button>
    </Box>
  );
}
